module.exports = __webpack_public_path__ + "img/publicprofile-share.af219b19.svg";